export default __webpack_public_path__ + "static/media/footer-phone-display-mobile.9e95b33b.png";